import { Component, inject, Input } from '@angular/core';
import { IonButton, IonCol, IonGrid, IonRow } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import {
  getEmptyFreightBasicForShipper,
  getEmptyFreightDetailForShipper,
  IFreightBasicForShipper,
  IFreightDetailedForShipper,
  UUID_NULL,
} from '@okcargo-apps/shared-domain';
import { FreightShipperFormsTriggersService } from '../freight-shipper-forms-triggers.service';

@Component({
  selector: 'lib-freight-shipper-footer-buttons',
  templateUrl: './freight-shipper-footer-buttons.component.html',
  styleUrls: ['./freight-shipper-footer-buttons.component.scss'],
  imports: [IonButton, IonCol, IonRow, IonGrid, TranslateModule],
})
export class FreightShipperFooterButtonsComponent {
  private readonly freightShipFormsTriggersService = inject(FreightShipperFormsTriggersService);

  @Input()
  id!: string;

  public freight: IFreightDetailedForShipper = getEmptyFreightDetailForShipper();
  public freightBasic: IFreightBasicForShipper = getEmptyFreightBasicForShipper();

  public isNew(): boolean {
    return this.id === UUID_NULL;
  }

  public updateOrCreateFreight(): void {
    this.freightShipFormsTriggersService.launchFreightShipperSaveTrigger();
  }

  public addStop(): void {
    this.freightShipFormsTriggersService.launchAddStopTrigger();
  }
}
